export enum CaseCardType {
  Base = 'base',
  Candidate = 'candidate',
}

export const baseCardHeight = 260;
export const gapHeight = 20;
export const logisticsStatusesHeaderHeight = 24;
export const logisticsStatusHeight = 24;
export const outcomeHeight = 12;
export const declineDataHeight = 84;
export const timelineHeight = 72;
export const clinicalDataHeight = 144;
export const invoicesHeight = 52;
export const serviceConfirmationHeight = 198;
export const scsCaseStatusHeight = 32;
